var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUrlTransferTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.303,
    height: 16.302,
    viewBox: "0 0 16.303 16.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link_2_",
    "data-name": "link (2)",
    d: "M10.32,12.989,7.136,16.173a2.068,2.068,0,0,1-2.872,0,2.027,2.027,0,0,1,0-2.872l3.184-3.184A.824.824,0,0,0,6.282,8.952L3.1,12.144a3.676,3.676,0,0,0,5.195,5.195l3.192-3.184a.824.824,0,1,0-1.165-1.165Zm7.041-9.913a3.685,3.685,0,0,0-5.195,0L8.974,6.26a.824.824,0,0,0,1.165,1.165l3.184-3.184a2.068,2.068,0,0,1,2.872,0,2.027,2.027,0,0,1,0,2.872L13.011,10.3a.824.824,0,1,0,1.165,1.165L17.361,8.27a3.685,3.685,0,0,0,0-5.195ZM7.628,12.808a.832.832,0,0,0,1.165,0l4.037-4.037a.824.824,0,1,0-1.165-1.165L7.628,11.643a.821.821,0,0,0,0,1.165Z",
    transform: "translate(-2.129 -2.005)",
    fill: "#00d297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrlTransferTable);
export default __webpack_public_path__ + "static/media/url_transfer_table.cf567aaad2b1bafe177f26eb77990f09.svg";
export { ForwardRef as ReactComponent };